import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-circle",
  "use": "arrow-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-circle\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#3483B2\" /><path fill=\"#FFF\" d=\"m12.55 6 6.2 6-6.2 6-1.3-1.25 4.13-4H6v-1.5h9.38l-4.13-4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol